<template>
  <router-link :to="{ name: 'boxReportsMetrics', params: { locale: i18n.locale, boxId: box.id }}" class="kp-select-open">
    <i class="fa fa-bar-chart"></i>{{ $t('general.actions.report') }}
  </router-link>
</template>

<script>
import i18n from '../../../../i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  props: [
    'box',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** ButtonReport.vue?fe8394d6
 **/